import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import logo from "../../../../assets/images/logo.svg";
import { useLanguage } from "../../../../context/LanguageProvider";
import { ROUTES } from "../../../../shared/constants/routes";
import ButtonLink from "../../../../shared/components/elements/ButtonLink";
import ProgressBar from "../../../../shared/components/elements/ProgressBar";
import Wrapper from "../../../../shared/components/layout/Wrapper";
import { LESSON_MESSAGES } from "../../messages";

interface HeaderLessonProps {
    progress?: number; // 0-100. Leave it out to hide the progress bar (projects, messages)
}

const HeaderLesson = ({ progress }: HeaderLessonProps) => {
    const { course_id } = useParams<{ course_id: string }>();
    const { lang, t } = useLanguage();

    return (
        <header className="mb-4 border-b-4 border-gray-200 py-3">
            <Wrapper>
                <div className="w-full flex flex-col flex-1 items-center">
                    <div className="w-full flex flex-1 justify-between items-center">
                        <div className="flex gap-x-3 items-center">
                            <img src={logo} alt="" className="h-16" />
                            <span className="text-2xl font-bold">{t.nav.brand}</span>
                        </div>

                        {course_id && (
                            <div className="mr-auto flex gap-x-5">
                                <ButtonLink to={ROUTES.myCourseContent(lang, course_id)}>
                                    <span className="sr-only">{LESSON_MESSAGES.backToCourse}</span>
                                    <FontAwesomeIcon icon={faArrowLeft} className="rotate-180" />
                                </ButtonLink>
                            </div>
                        )}
                    </div>

                    {progress !== undefined && (
                        <ProgressBar value={progress} max={100} className="mt-4 lg:mt-8" />
                    )}
                </div>
            </Wrapper>
        </header>
    );
};

export default HeaderLesson;